import { Component } from "@angular/core";
import { Store } from "@ngrx/store";
import { combineLatest } from "rxjs";
import { filter, map } from "rxjs/operators";
import { HamptonComparable } from "src/app/core/valuation-process/_models/hampton-comparable.model";
import { VComparable } from "src/app/core/valuation-process/_models/valuation-comparable.model";
import { selectValuationProcessSelectedComparables, selectValuationProcessSelectedComparablesFull } from "src/app/core/valuation-process/_selectors";
import { selectValuationProcessConsiderationCriterion } from "src/app/core/valuation-process/_selectors/consideration-criterion.selector";
import { selectValuationProcessSelectedComparablesInHampton, selectValuationProcessTargetPropertyUnitMAcronym } from "src/app/core/valuation-process/_selectors/valuation-process.selectors";

interface Comparable {
  refNum: string,
  buildingName: string,
  size: number,
  price: number,
  bua: number,
  date: Date,
  evidenceType: string
}

@Component({
  selector: 'app-comparables-table',
  templateUrl: './comparables-table.component.html',
  styleUrls: ['./comparables-table.component.scss']
})
export class ComparablesTableComponent {
  columns = ['building', 'size', 'price', 'bua', 'date', 'evidence']
  unitMeasurement$ = this.store$.select(selectValuationProcessTargetPropertyUnitMAcronym)
  consideration$ = this.store$.select(selectValuationProcessConsiderationCriterion)
  currency$ = this.consideration$.pipe(
    map(consideration => consideration.countryCurrency)
  )

  viewModel$ = combineLatest([
    this.store$.select(selectValuationProcessSelectedComparablesInHampton),
    this.unitMeasurement$,
    this.currency$
  ]).pipe(
    map(([comparables, unitMeasurement, currency]) => {
      return {
        currency,
        unit: unitMeasurement,
        dataSource: comparables.map(comparable => this.mapComparablesToTableViewModel(comparable))
      }
    })
  )

  constructor(
    private store$: Store
  ) {}

  private mapComparablesToTableViewModel(comparable: HamptonComparable): Comparable {
    return {
      refNum: comparable.refNum,
      buildingName: comparable.buildingName,
      size: comparable.size,
      price: comparable.price,
      bua: comparable.size == 0
        ? 0
        : comparable.price / comparable.size,
      date: comparable.sourceDate,
      evidenceType: comparable.sourceType 
    }
  }
} 